import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
import { DateTime } from 'luxon';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLAOilGasLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Oil & Gas Well Permits (FDEP)',
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/OIL_WELLS/MapServer/0',
        visible: false,
        popupTemplate: {
            outFields: ['*'],
            title: 'Oil & Gas Well Permits (FDEP)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Permit Number" value={atts.PERMIT_NO} />
                        <BSLAPopupItemComponent label="OG Number" value={atts.OG_NUMBER} />
                        <BSLAPopupItemComponent label="API Number" value={atts.API_NO} />
                        <BSLAPopupItemComponent label="Status" value={atts.STATUS} />
                        <BSLAPopupItemComponent label="Count" value={atts.COUNTY} />
                        <BSLAPopupItemComponent label="Oil Field" value={atts.OILFIELD} />
                        <BSLAPopupItemComponent label="Company" value={atts.COMPANY} />
                        <BSLAPopupItemComponent label="Well Name" value={atts.WELLNAME} />
                        <BSLAPopupItemComponent label="Completion Date" value={atts.COMPLETION ? DateTime.fromMillis(atts.COMPLETION).toFormat('MMM dd, yyyy') : 'N/A'} />
                        <BSLAPopupItemComponent label="Plug Date" value={atts.PLUGDATE ? DateTime.fromMillis(atts.PLUGDATE).toFormat('MMM dd, yyyy') : 'N/A'} />
                        <BSLAPopupItemComponent label="SPUD Date" value={atts.SPUD_DATE ? DateTime.fromMillis(atts.SPUD_DATE).toFormat('MMM dd, yyyy') : 'N/A'} />
                        <div className="mt-3">
                            <BSLAExternalLinkComponent href={atts.DOCUMENTS} />
                        </div>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAOilGasLayer;
